import React, { useState } from 'react';
import logoMap from './Logo - MAP-Géstion.png';

import API from './config';
const BLEU = '#1E3A5F';

export default function Login({ onConnecte }) {
  const [etape, setEtape] = useState('login'); // 'login' | 'configurer_2fa' | 'saisir_code'
  const [email, setEmail] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [tokenTemp, setTokenTemp] = useState('');
  const [qrCode, setQrCode] = useState('');
  const [secret, setSecret] = useState('');
  const [code, setCode] = useState('');
  const [erreur, setErreur] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErreur('');
    setLoading(true);
    try {
      const r = await fetch(`${API}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, mot_de_passe: motDePasse })
      });
      const data = await r.json();
      if (!r.ok) { setErreur(data.detail || 'Erreur de connexion'); setLoading(false); return; }

      setTokenTemp(data.token_temporaire);
      if (data.etape === 'configurer_2fa') {
        setQrCode(data.qr_code);
        setSecret(data.secret);
        setEtape('configurer_2fa');
      } else {
        setEtape('saisir_code');
      }
    } catch { setErreur('Impossible de contacter le serveur'); }
    setLoading(false);
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setErreur('');
    setLoading(true);
    try {
      const r = await fetch(`${API}/auth/verify-2fa`, {
        method: 'POST',
        credentials: 'include',  // Auto-envoyer les cookies (httpOnly JWT)
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token_temporaire: tokenTemp, code })
      });
      const data = await r.json();
      if (!r.ok) { setErreur(data.detail || 'Code incorrect'); setLoading(false); return; }

      localStorage.setItem('map_csrf_token', data.csrf_token);
      localStorage.setItem('map_user', JSON.stringify(data.utilisateur));
      onConnecte(data.utilisateur, data.csrf_token);  // JWT en cookie, pas en localStorage
    } catch { setErreur('Impossible de contacter le serveur'); }
    setLoading(false);
  };

  const s = {
    page: { minHeight: '100vh', background: '#F7F8FA', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Inter, Arial, sans-serif' },
    card: { background: 'white', borderRadius: '12px', padding: '40px', width: '400px', boxShadow: '0 8px 32px rgba(0,0,0,0.12)' },
    input: { width: '100%', padding: '10px 14px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '15px', boxSizing: 'border-box', marginBottom: '12px' },
    btn: { width: '100%', background: BLEU, color: 'white', border: 'none', padding: '12px', borderRadius: '8px', fontSize: '15px', fontWeight: '700', cursor: 'pointer', marginTop: '4px' },
    label: { display: 'block', fontSize: '13px', color: '#374151', fontWeight: '600', marginBottom: '4px' },
    erreur: { background: '#FEF2F2', color: '#DC2626', padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' },
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img src={logoMap} alt="MAP Gestion" style={{ height: '80px', marginBottom: '8px' }} />
        </div>

        {erreur && <div style={s.erreur}>⚠️ {erreur}</div>}

        {/* Étape 1 — Login */}
        {etape === 'login' && (
          <form onSubmit={handleLogin}>
            <label style={s.label}>Email</label>
            <input style={s.input} type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="votre@email.fr" required autoFocus />
            <label style={s.label}>Mot de passe</label>
            <input style={s.input} type="password" value={motDePasse} onChange={e => setMotDePasse(e.target.value)} placeholder="••••••••" required />
            <button style={s.btn} type="submit" disabled={loading}>{loading ? 'Connexion...' : 'Se connecter'}</button>
            <button type="button" style={{ background:'none', border:'none', color:'#6B7280', fontSize:'13px', cursor:'pointer', marginTop:'12px', width:'100%', textAlign:'center' }}
              onClick={() => setEtape('mdp_oublie')}>
              Mot de passe oublié ?
            </button>
          </form>
        )}

        {/* Mot de passe oublié */}
        {etape === 'mdp_oublie' && (
          <form onSubmit={async (e) => {
            e.preventDefault(); setErreur(''); setLoading(true);
            await fetch(`${API}/auth/demande-reset`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ email }) });
            setLoading(false);
            setEtape('mdp_envoye');
          }}>
            <h3 style={{ color: BLEU, margin:'0 0 8px 0', fontSize:'16px' }}>Réinitialisation du mot de passe</h3>
            <p style={{ color:'#6B7280', fontSize:'13px', marginBottom:'16px' }}>Saisissez votre email. L'administrateur recevra votre demande et vous communiquera un nouveau mot de passe.</p>
            <label style={s.label}>Email</label>
            <input style={s.input} type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="votre@email.fr" required autoFocus />
            <button style={s.btn} type="submit" disabled={loading}>{loading ? 'Envoi...' : 'Envoyer la demande'}</button>
            <button type="button" style={{ background:'none', border:'none', color:'#6B7280', fontSize:'13px', cursor:'pointer', marginTop:'8px', width:'100%', textAlign:'center' }}
              onClick={() => setEtape('login')}>← Retour</button>
          </form>
        )}

        {/* Confirmation envoi */}
        {etape === 'mdp_envoye' && (
          <div style={{ textAlign:'center' }}>
            <div style={{ fontSize:'48px', marginBottom:'16px' }}>✅</div>
            <h3 style={{ color: BLEU, margin:'0 0 8px 0' }}>Demande envoyée</h3>
            <p style={{ color:'#6B7280', fontSize:'13px', marginBottom:'24px' }}>L'administrateur a été notifié. Il vous communiquera votre nouveau mot de passe.</p>
            <button style={s.btn} onClick={() => { setEtape('login'); setEmail(''); }}>Retour à la connexion</button>
          </div>
        )}

        {/* Étape 2a — Configuration 2FA (première connexion) */}
        {etape === 'configurer_2fa' && (
          <form onSubmit={handleVerify}>
            <h3 style={{ color: BLEU, margin: '0 0 8px 0', fontSize: '16px' }}>Configuration de l'authentification à deux facteurs</h3>
            <p style={{ color: '#6B7280', fontSize: '13px', marginBottom: '16px' }}>
              1. Installez <strong>Google Authenticator</strong> ou <strong>Authy</strong> sur votre téléphone.<br />
              2. Scannez le QR code ci-dessous.<br />
              3. Saisissez le code à 6 chiffres affiché.
            </p>
            {qrCode && (
              <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                <img src={`data:image/png;base64,${qrCode}`} alt="QR Code 2FA" style={{ width: '180px', height: '180px', border: '4px solid #F3F4F6', borderRadius: '8px' }} />
                <div style={{ fontSize: '11px', color: '#9CA3AF', marginTop: '6px' }}>
                  Code manuel : <code style={{ fontSize: '11px', background: '#F3F4F6', padding: '2px 6px', borderRadius: '4px' }}>{secret}</code>
                </div>
              </div>
            )}
            <label style={s.label}>Code à 6 chiffres</label>
            <input style={{ ...s.input, textAlign: 'center', fontSize: '24px', letterSpacing: '8px', fontWeight: '700' }}
              type="text" inputMode="numeric" maxLength={6} value={code}
              onChange={e => setCode(e.target.value.replace(/\D/g, ''))} placeholder="000000" required autoFocus />
            <button style={s.btn} type="submit" disabled={loading || code.length !== 6}>
              {loading ? 'Vérification...' : 'Activer et se connecter'}
            </button>
          </form>
        )}

        {/* Étape 2b — Saisie code 2FA (connexions suivantes) */}
        {etape === 'saisir_code' && (
          <form onSubmit={handleVerify}>
            <h3 style={{ color: BLEU, margin: '0 0 8px 0', fontSize: '16px' }}>Code de vérification</h3>
            <p style={{ color: '#6B7280', fontSize: '13px', marginBottom: '20px' }}>
              Ouvrez Google Authenticator et saisissez le code affiché pour MAP Gestion.
            </p>
            <input style={{ ...s.input, textAlign: 'center', fontSize: '28px', letterSpacing: '10px', fontWeight: '700' }}
              type="text" inputMode="numeric" maxLength={6} value={code}
              onChange={e => setCode(e.target.value.replace(/\D/g, ''))} placeholder="000000" required autoFocus />
            <button style={s.btn} type="submit" disabled={loading || code.length !== 6}>
              {loading ? 'Vérification...' : 'Valider'}
            </button>
            <button type="button" style={{ ...s.btn, background: 'transparent', color: '#6B7280', marginTop: '8px', fontWeight: '400', fontSize: '13px' }}
              onClick={() => { setEtape('login'); setCode(''); setErreur(''); }}>
              ← Retour
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
